import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from './supabase.js';

// Auth model = the shared preorder-app model: Supabase email/password users with a
// public.profiles row (role enum: front_staff | purchasing | manager). Cost access
// (RLS public.has_cost_access()) = purchasing + manager.
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(undefined); // undefined = loading
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session ?? null));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => sub.subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!session?.user) { setProfile(null); return; }
    supabase.from('profiles').select('id, full_name, role, is_active')
      .eq('id', session.user.id).maybeSingle()
      .then(({ data }) => setProfile(data ?? null));
  }, [session?.user?.id]);

  const signIn = (email, password) => supabase.auth.signInWithPassword({ email, password });
  const signOut = () => supabase.auth.signOut();
  const hasCostAccess = !!profile && profile.is_active && ['purchasing', 'manager'].includes(profile.role);

  return (
    <AuthCtx.Provider value={{ session, profile, signIn, signOut, hasCostAccess }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
